// removed by extract-text-webpack-plugin
module.exports = {"overlay":"MatchRowOverlay__overlay___22YKg","overlayRow":"MatchRowOverlay__overlayRow___1INyZ","rejectText":"MatchRowOverlay__rejectText___1z_7D","cancelButton":"MatchRowOverlay__cancelButton___2S6oB","rejectButton":"MatchRowOverlay__rejectButton___3q0A2"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/candidate/projects/matches/components/matchRowOverlay/MatchRowOverlay.scss
// module id = 1829
// module chunks = 0